import { render, staticRenderFns } from "./HeroBarMain.vue?vue&type=template&id=5aa7ce44&"
import script from "./HeroBarMain.vue?vue&type=script&lang=js&"
export * from "./HeroBarMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports